import React from 'react';
import { observer } from 'mobx-react-lite';
import { SummarySection } from './SummarySection';
import { useMyHealthStore } from 'store/mobx/mobx';
import { BaseSectionItem } from './BaseSectionItem';
import moment from 'moment';

function getTooltipText(item: any) {
  if (item.Name) {
      return [`Description: ${item.Description}`, `Date: ${moment(item.DiagnosisDate).format('DD/MM/YYYY')}`, `Practice: ${item.OrganisationName}`, `Practitioner: ${item.ProviderName}`];
  }
}

export const ProceduresSection: React.FC = observer(() => {
  const { Procedures } = useMyHealthStore().summaryTab;

  return (
    <SummarySection title="Procedures/operations" observableData={Procedures}>
      {Procedures.map(item => (
        <BaseSectionItem
          key={item.Id}
          label={item.Name}
          date={item.DiagnosisDate}
          tooltipText={getTooltipText(item)}
        />
      ))}
    </SummarySection>
  );
});
